export default __webpack_public_path__ + "linkedin-sign.png";